import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
// import 'ant-design-vue/dist/antd.less'
import 'ant-design-vue/dist/reset.css'
// import 'ant-design-vue/es/style/index.less';
import './css/common.less'
import * as Icons from '@ant-design/icons-vue'
import 'default-passive-events'
import SvgIcon from '@/components/icons/svgIcon.vue'
import importAllSvgIcons from './svg/index'
import { permission, hidePermission } from "@/utils/permission";
import '@/utils/browser_patch'
const app = createApp(App)
app.use(Antd).use(store).use(router)
const icons = Icons
for (const name in icons){
    app.component(name,(icons as any)[name])
}
// 添加到全局
app.config.globalProperties.$antIcons = Icons
app.component('svg-icon', SvgIcon) // 全局注册svg-icon组件。
importAllSvgIcons()
app.directive('has', permission)
app.directive('hide', hidePermission)
app.mount('#app')
